// extracted by mini-css-extract-plugin
export var star = "recommendtop-module--star--011ee";
export var unstar = "recommendtop-module--unstar--29bcd";